import { Dropdown, DropdownTrigger, DropdownMenu, DropdownItem, Button } from '@heroui/react';
import { useTheme, type ThemeMode } from '@/contexts/ThemeContext';
import { SunIcon, MoonIcon, ComputerDesktopIcon } from '@/icons';

/**
 * Theme control with three explicit choices (Light / Dark / System). The
 * trigger icon reflects the currently-resolved scheme; selection persists and
 * flips the <html> class immediately (no reload).
 */
export function ThemeToggle() {
  const { mode, resolved, setMode } = useTheme();

  const items: Array<{ key: ThemeMode; label: string; icon: JSX.Element }> = [
    { key: 'light', label: 'Light', icon: <SunIcon className="h-4 w-4" /> },
    { key: 'dark', label: 'Dark', icon: <MoonIcon className="h-4 w-4" /> },
    { key: 'system', label: 'System', icon: <ComputerDesktopIcon className="h-4 w-4" /> },
  ];

  return (
    <Dropdown placement="bottom-end">
      <DropdownTrigger>
        <Button isIconOnly variant="light" size="sm" aria-label="Change theme" className="text-fg-muted">
          {resolved === 'dark' ? <MoonIcon className="h-5 w-5" /> : <SunIcon className="h-5 w-5" />}
        </Button>
      </DropdownTrigger>
      <DropdownMenu
        aria-label="Theme"
        selectionMode="single"
        selectedKeys={new Set([mode])}
        onAction={(key) => setMode(key as ThemeMode)}
      >
        {items.map((it) => (
          <DropdownItem key={it.key} startContent={it.icon}>{it.label}</DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}
